import React from "react"

import { usePackages } from "../../../../hooks/usePackages"
import { useTemplate } from "../../../../hooks/useTemplate"

export const withPackages = Component => ({ name = "Packages", title }) => {
  const { packages } = usePackages()
  const { global: locales } = useTemplate()

  Component.displayName = name
  return <Component locales={locales} packages={packages} title={title} />
}
